import {
  createUserProfile,
  fetchUserProfile,
  patchUserProfile,
} from "../repositories/userRepository";
import { isRallyAllyAccountEmail, rallyAllyUserIdFromEmail } from "../domain/auth/rallyAllyAuthEmail";

export async function getUserProfile(uid) {
  return fetchUserProfile(uid);
}

export async function ensureUserProfile(uid) {
  const existing = await fetchUserProfile(uid);
  if (existing) return existing;

  try {
    await createUserProfile(uid);
  } catch (err) {
    const afterRace = await fetchUserProfile(uid);
    if (afterRace) return afterRace;
    throw err;
  }

  const created = await fetchUserProfile(uid);
  if (!created) throw new Error("User profile was not created");
  return created;
}

/**
 * @param {import('firebase/auth').User} authUser
 */
export async function syncUserProfileFromAuthUser(authUser) {
  await ensureUserProfile(authUser.uid);
  const patch = {};
  if (authUser.displayName && !isRallyAllyAccountEmail(authUser.displayName)) {
    patch.displayName = authUser.displayName;
  }
  if (authUser.email) {
    patch.email = authUser.email;
    if (!patch.displayName && isRallyAllyAccountEmail(authUser.email)) {
      const id = rallyAllyUserIdFromEmail(authUser.email);
      if (id) patch.displayName = id;
    }
  }
  if (authUser.photoURL) patch.photoURL = authUser.photoURL;
  if (Object.keys(patch).length > 0) {
    await patchUserProfile(authUser.uid, patch);
  }
  return fetchUserProfile(authUser.uid);
}
